import { render, staticRenderFns } from "./CompaniesAddUser.vue?vue&type=template&id=a801a812&scoped=true&lang=pug&"
import script from "./CompaniesAddUser.vue?vue&type=script&lang=js&"
export * from "./CompaniesAddUser.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesAddUser.vue?vue&type=style&index=0&id=a801a812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a801a812",
  null
  
)

export default component.exports